import React, { useEffect } from "react";
import { Col, Row } from "antd";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import ProductDetail from "@components/ProductDetail";
import Information from "@components/Information";
import { getFinishedDetailProduct } from "@dataLayer/product";

import './index.scss';

const HistoryDetailPage = () => {
  const { t } = useTranslation();
  const { cp_id } = useParams();
  const { data: product } = useQuery(getFinishedDetailProduct(cp_id));

  useEffect(() => {
    document.title = t("title.finished_detail");
  }, [t]);

  return (
    <div className="history-detail-page">
      <div className="history-detail-page-wrapper">
        <Row justify="center">
          <Col xs={24}>
            <ProductDetail
              product={product}
              isHistory={true}
              isPotentialWinner={false}
            />
            <Information product={product} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default HistoryDetailPage;
